@if (verrous.length > 0) {
	<div class="alert alert-warning rounded-4 d-flex flex-wrap align-items-center justify-content-between gap-2" role="alert">
		<div>
			<i class="ri-lock-2-line align-middle me-1"></i>
			<span class="fw-medium">{{ libelle }} est {{ description }}.</span>
			La modification est bloquée tant qu'il n'a pas terminé ; la consultation reste possible.
		</div>
		@if (isAdmin) {
			<gm-button-primary label="Forcer le déverrouillage" color="warning" [loading]="isForcing" (clickBtn)="forcer()"></gm-button-primary>
		}
	</div>
}
